import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../Helpers/Utils";
import { useParams } from "react-router-dom";
import Select from "react-select";

const UpdateCustomer = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const loading = useSelector(s => s.loading.loading);

    const [form, setForm] = useState({
        customer_code: "",
        company_name: "",
        uen: "",
        gst_registered: 0,
        billing_address: "",
        contact_person: "",
        phone: "",
        email: "",
        status: "active"
    });

    const statusOptions = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" }
    ];

    /* load customer */
    const loadCustomer = async () => {
        dispatch(loadingTrue());
        const res = await Handler({ method: "get", url: `/customer/view.php?id=${id}` });
        if (res.success) {
            setForm(res.data);
        }
        dispatch(loadingFalse());
    };

    useEffect(() => { loadCustomer(); }, []);

    const handleChange = e => {
        const { name, value, type, checked } = e.target;
        setForm({ ...form, [name]: type === "checkbox" ? (checked ? 1 : 0) : value });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        dispatch(loadingTrue());

        const res = await Handler({
            method: "post",
            url: "/customer/update.php",
            data: { id, ...form }
        });

        if (res.success) {
            toast.success(res.message);
            setTimeout(() => reloadWindowToPath("/customers"), 1000);
        } else {
            toast.error(res.message);
        }

        dispatch(loadingFalse());
    };

    return (
        <div className="page-card">
            <div className="page-header"><h4>Edit Customer</h4></div>

            <form onSubmit={handleSubmit} className="form-grid">

                <div className="form-group">
                    <label>Customer Code</label>
                    <input name="customer_code" className="form-control" value={form.customer_code || ""} placeholder="Enter unique customer code" onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>Company Name</label>
                    <input name="company_name" className="form-control" value={form.company_name || ""} placeholder="Enter company name" onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>UEN</label>
                    <input name="uen" className="form-control" value={form.uen || ""} placeholder="Enter UEN / registration number" onChange={handleChange} required />
                </div>

                <div className="form-group gst-toggle">
                    <label>GST Registered</label>
                    <label className="switch">
                        <input type="checkbox" name="gst_registered" checked={form.gst_registered == 1} onChange={handleChange} />
                        <span className="slider"></span>
                    </label>
                </div>

                <div className="form-group">
                    <label>Status</label>
                    <Select
                        options={statusOptions}
                        value={statusOptions.find(o => o.value === form.status)}
                        onChange={(selected) => setForm({ ...form, status: selected.value })}
                    />
                </div>

                <div className="form-group full">
                    <label>Billing Address</label>
                    <textarea name="billing_address" className="form-control" rows="2" value={form.billing_address || ""} placeholder="Enter billing address" onChange={handleChange} required></textarea>
                </div>

                <div className="form-group">
                    <label>Person InCharge</label>
                    <input name="contact_person" className="form-control" value={form.contact_person || ""} placeholder="Enter person in charge name" onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>Phone</label>
                    <input name="phone" className="form-control" value={form.phone || ""} placeholder="Enter phone number" onChange={handleChange} required />
                </div>

                <div className="form-group">
                    <label>Email</label>
                    <input type="email" name="email" className="form-control" value={form.email || ""} placeholder="Enter email address" onChange={handleChange} required />
                </div>

                <div className="form-group full">
                    <button className="btn add-btn-add" disabled={loading}>
                        {loading ? (<><span className="spinner-border spinner-border-sm me-2"></span>Updating...</>) : "Update Customer"}
                    </button>
                </div>

            </form>
        </div>
    );
};

export default UpdateCustomer;